import MC from "components/Stacker/constants/ModalConstants"

export const initialState = {}

export default function modalReducer(previousState = initialState, action) {
  let newObj
  switch (action.type) {
    case MC.MODAL_CREATE:
      return {
        ...previousState,
        [action.payload]: false,
      }

    case MC.MODAL_SHOW:
      return {
        ...previousState,
        [action.payload.modalName]: true,
      }

    case MC.MODAL_HIDE:
      return {
        ...previousState,
        [action.payload.modalName]: false,
      }

    case MC.MODAL_TOOGLE:
      return {
        ...previousState,
        [action.payload.modalName]: !previousState[action.payload.modalName],
      }

    case MC.MODAL_DESTROY:
      newObj = {
        ...previousState,
      }
      delete newObj[action.payload]
      return newObj

    default:
      return previousState
  }
}
